import React from 'react';

export class VideoOverlay extends React.Component {
  constructor () {
    super();
    this.state = { visible: false, target: null };
  }

  componentDidMount () {
    window.videoOverlay = this;
  }

  show (target) {
    this.setState({ target, visible: true }, () => {
      this.overlay.addEventListener('click', this.hide);
    });
  }

  hide = () => {
    this.setState({ target: null, visible: false });
  }

  get videoId () {
    var VID_REGEX = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    return this.state.target.match(VID_REGEX)[1];
  }

  get content () {
    if (typeof this.state.target === 'string') {
      if (this.state.target.indexOf('youtu') > -1) {
        return (<div className="video-overlay__youtube">
          <iframe src={`https://www.youtube.com/embed/${this.videoId}?autoplay=1&modestbranding=1`} allow='autoplay' />
        </div>);
      }
    }
  }

  render () {
    return this.state.visible ? (
      <div className="video-overlay" ref={_ => this.overlay = _}>
        <div className="overlay__background" />
        <div className="video-overlay__content">
          { this.state.target && this.content }
        </div>
      </div>
    ) : '';
  }
}

const getVideoId = (url) => {
  
};
